var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',[_c('v-toolbar-title',[(!_vm.isLastStep)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.header())}}):_vm._e(),(_vm.isLastStep)?_c('CapTranslation',{attrs:{"translation":"header.last_page_title","params":{ financiersNum: _vm.financiersNum }}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }